// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SpreadsheetDetails{height:100%}", "",{"version":3,"sources":["webpack://./src/main/js/modules/spreadsheets/pages/spreadsheet-details/spreadsheet-details.styles.scss"],"names":[],"mappings":"AAAA,oBACE,WAAA","sourcesContent":[".SpreadsheetDetails {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
